export interface IAcceptPolicyDialogData {
    locale: string;
}
